import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface WrappedSettingValue {
  enabled: boolean;
}

interface AppSettingRow {
  key: string;
  value: { enabled: boolean };
  updated_at: string | null;
  updated_by: string | null;
}

export function useWrappedEnabled() {
  const { data, isLoading } = useQuery({
    queryKey: ["app-settings", "wrapped_enabled"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("app_settings")
        .select("*")
        .eq("key", "wrapped_enabled")
        .single();

      if (error) {
        console.error("Error fetching wrapped setting:", error);
        return null;
      }

      return data as AppSettingRow;
    },
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  // Extract enabled value from the row
  // Default to FALSE during loading to prevent flash of content
  const settingValue = data?.value as unknown as WrappedSettingValue | undefined;
  const isEnabled = settingValue?.enabled ?? false;

  return {
    isWrappedEnabled: isEnabled,
    isLoading,
  };
}
